// extracted by mini-css-extract-plugin
export default {"container":"InvadersList_container__bR-DB","invader":"InvadersList_invader__fgf8D","linkInvader":"InvadersList_linkInvader__3XQ6I"};